package learning.containers


import com.jingfangpai.api.clients.ContentApiClient
import react.*
import react.dom.div
import setTitle
import learning.components.Meridians

external interface MeridiansPageProps : RProps {

}

data class MeridiansPageContextData(var query:(query:com.jingfangpai.content.model.ContentQuery, okCallback: (result:com.jingfangpai.common.data.response.ApiResponse<kotlin.Array<com.jingfangpai.content.model.ContentVo>>) -> Unit, errorCallback: (exception:Throwable) -> Unit) -> Unit)

val MeridiansPageContext = createContext(MeridiansPageContextData(ContentApiClient::query))

val MeridiansPageProvider = functionalComponent<MeridiansPageProps> { props ->

    setTitle("十四经络")

    fun placeHolderFunction(param: String) {
        console.log("doing something with param")
    }

    useEffectOnce { }

    MeridiansPageContext.Provider(MeridiansPageContextData(ContentApiClient::query)) {
        div("MeridiansPage-content") {
            child(Meridians) {

            }
        }
    }
}
